export const optimization = {
  score: 82,
  items: [
    { id: 'opt_1', title: 'Add negative keywords to Brand — Search', impact: 'medium', status: 'open' },
    { id: 'opt_2', title: 'Shift budget from TikTok Awareness to Meta Retargeting', impact: 'high', status: 'open' },
  ],
};
